import { validationExitRoles } from "../actions/actionPerform";
import {
    USER_LOADED,
    LOGOUT_SUCCESS,
    SAVE_TOKEN,
    VALID_USER,
    IS_USER_CREATE,
} from "../constants/action-types";

const initialState = {
    isAuthenticated: JSON.parse(sessionStorage.getItem("isAuthenticated")),
    username: localStorage.getItem("username") !== null ?  localStorage.getItem("username") : "",
    pass: localStorage.getItem("password") !== null ?  localStorage.getItem("password") : "",
    token: '',
    group: {},
    groups: ["name", "Admin"],
    isUserValid: sessionStorage.getItem("isUserValid") !== undefined ? JSON.parse(sessionStorage.getItem("isUserValid")) : false,
};

const auth = (state = initialState, action ) => {
    switch (action.type) {
        case VALID_USER:
            sessionStorage.setItem("isUserValid", action.payload);
            return {
                ...state,
                isUserValid: action.payload
            };
        case SAVE_TOKEN:
            sessionStorage.setItem("token", action.payload);
            sessionStorage.setItem("isAuthenticated", true);
            return {
                ...state,
                token: action.payload,
                isAuthenticated: true
            };
        case USER_LOADED:
            sessionStorage.setItem("username", action.payload.username);
            sessionStorage.setItem("password", action.payload.password);
            return {
                ...state,
                username: action.payload.username,
                password: action.payload.password
        };
        case IS_USER_CREATE:
            // localStorage.setItem("isUserCreate", action.payload)
            return {
                ...state,
                isUserCreate: action.payload,
            };
        case LOGOUT_SUCCESS:
            validationExitRoles();
            sessionStorage.setItem("isAuthenticated", false);
            sessionStorage.setItem("username", "");
            sessionStorage.setItem("password", "");
            sessionStorage.setItem("token", "");
            sessionStorage.setItem("isUserValid", false);
            sessionStorage.setItem("isConfigUser", false);
            sessionStorage.setItem("isValidKey", false);
            return {
                ...state,  
                isAuthenticated: false,
                username: "",
                password: "",
                token: "",
                isUserValid: false,
                isConfigUser: false,
                isValidKey: false
            };
        default:
            return state;
    }
};

export default auth;
